import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e666409e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Information du produit", -1))
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_3 = { class: "item-bloc-form p-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "info produit", -1))
const _hoisted_5 = { class: "item-bloc-form p-5" }
const _hoisted_6 = { class: "item-bloc-form p-5" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Fournisseur", -1))
const _hoisted_8 = {
  key: 0,
  class: "item-bloc-form p-5"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Gestion du stock", -1))
const _hoisted_10 = { class: "grid grid-cols-2 grid-rows-1 gap-6" }
const _hoisted_11 = {
  key: 1,
  class: "item-bloc-form p-5"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Connexions", -1))
const _hoisted_13 = {
  key: 2,
  class: "item-bloc-form p-5"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Redirection & réduction", -1))
const _hoisted_15 = {
  key: 3,
  class: "item-bloc-form p-5"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Code promotionnel", -1))
const _hoisted_17 = {
  key: 4,
  class: "item-bloc-form p-5"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Politique de prix", -1))
const _hoisted_19 = { class: "grid grid-cols-1 md:grid-cols-4" }
const _hoisted_20 = { class: "pr-5" }
const _hoisted_21 = { class: "pr-5" }
const _hoisted_22 = { class: "pr-5" }
const _hoisted_23 = { class: "pr-5" }
const _hoisted_24 = {
  key: 5,
  class: "item-bloc-form p-5"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Conditions d’utilisation", -1))
const _hoisted_26 = { class: "item-bloc-form p-5" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Géolocalisation", -1))

import ApiService from "@/_services/api.service"
  import Property from "@/models/product/property/Property";
  import PropertyValue from "@/models/product/property/PropertyValue";
  import TagListOptions from "@/models/modules/formkit/TagListOptions";
  import {onMounted, Ref, ref, computed, watch} from "vue";
  import { useProductStore } from "@/stores/product/prototypeStore";
  import { urssafEvent, urssafClassification } from "@/constants/product/properties";
  import { taxes } from "@/constants/product/taxes";
  import FormGeolocation from "@/components/forms/product/FormGeolocation.vue";
  import {getOptionsCountry} from "@/_services/geolocation/country";

  interface PropertyValuePayload {
    name: string;
    uuid: string;
  }
  const maximumDecimalsError = 'Maximum 2 décimales après la virgule.';
  const maxErrorMEssage = 'Ce champ doit comporter maximum 17 décimales';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'InformationStep',
  setup(__props) {

  let optionsCountry = getOptionsCountry();
  
  const driveOptions = [
    { label: 'Utilisable en drive', value: true },
    { label: 'Non utilisable en drive', value: false },
    { label: 'Information non renseignée', value: null }
  ];
  const selectedDriveOption = ref(null);

  let propertyBrand: Property;
  let propertyUrssafEvent = ref({});
  let socialEvent = ref<{ label: string; value: string}[]>([]);
  let propertyUrssafClassification = ref({});
  let propertyTaxes = ref({});
  let is_sale_closed = ref();
  let discount_type = ref(2);
  let geolocationOptions = ref();
  let typesGeolocationUuid = ref();
  let geolocation_type = ref('');
  const closure_reason = ref('');
  const publicPriceClosed = ref('');
  const reductionDescriptionClosed = ref('');
  const reductionValueClosed = ref('');
  const geolocationApiKeyClosed = ref('');
  const geolocationAddresses = ref([]);
  const purchasingPrice = ref([]);

  let is_discount = ref(1);
  const selectedBrand: Ref<PropertyValuePayload | null> = ref(null);
  let supplier_model = ref('');
  let optionsShippingMethods = ref([]);
  let shippingMethod_model  = ref([]);
  onMounted(async () => {
    await getBrand();
    await getUrssafEvent();
    await getUrssafClassification();
    await getTaxes();
    await getTypesGeolocationOptions();
    await getSocialEvent();
  })
  

  const promoCode = ref('');
  const phoneNumber = ref('');

  const phoneNumberValidation = computed(() => {
    if (promoCode.value && !phoneNumber.value) {
      return 'required';
    }
    return 'length:0,20';
  });

  const searchInput = ref('');

  const searchValidation = computed(() => {
    if (searchInput.value.length > 50) {
      return 'searchLength'; // Return the validation error key
    } else {
      return null; // Return null if validation passes
    }
  });
  
  function maxBrandLength(node) {
    const value = node.value
    return value[0].length <= 50;
  }

  function maximumDecimals(node, maxDecimals = 2) {
    const value = node.value;
    const regex = new RegExp(`^\\d+(\\.\\d{1,${maxDecimals}})?$`);
    return regex.test(value);
  }

  function maximumDecimalsGeoloc(node, maxDecimals = 17) {
    const value = node.value;
    const regex = new RegExp(`^-?\\d+(\\.\\d{1,${maxDecimals}})?$`);
    return regex.test(value);
  }

  async function searchBrands({ search }) {
    if(!search || search.length <= 2) return [];
    
    return propertyBrand.propertyValues.reduce((accumulator: Array<TagListOptions>, brand: PropertyValue) => {
      if (brand.value.toLowerCase().includes(search.toLowerCase())) {
        accumulator.push({
          label: brand.value,
          value: brand.uuid
        })
      }
      return accumulator;
    }, []);
  }

  async function getBrand() {
    const fetchedBrand = await ApiService.get('properties/e7cc42c0-fa45-11ed-a0b1-de1c3c38600f');
    propertyBrand = fetchedBrand.data.data;
  }

  async function getUrssafEvent() {
    const fetchedUrssafEvent = await ApiService.get('properties/e7d653d5-fa45-11ed-a0b1-de1c3c38600f');
    propertyUrssafEvent.value = formatPropertyValueData(fetchedUrssafEvent.data.data);
  }

  function formatSocialEventData(response: any): { label: string; value: string }[] {
      const items = response;
      if (!Array.isArray(items)) return [];
      return items.map((item: any) => ({
          label: item.name,
          value: item.uuid
      }));
  }

  async function getSocialEvent() {
      try {
          const res = await ApiService.get('social_events');
          socialEvent.value = formatSocialEventData(res.data.data);
      } catch (error) {
          console.error('Erreur API socialEvent:', error);
      }
  }
  
  async function getUrssafClassification() {
    const fetchedUrssafClassification = await ApiService.get('properties/e7d49bb6-fa45-11ed-a0b1-de1c3c38600f');
    propertyUrssafClassification.value = formatPropertyValueData(fetchedUrssafClassification.data.data);
  }
  async function getTaxes() {
    const fetchedTaxes = await ApiService.get('taxes');
    const taxOptions = Object.keys(fetchedTaxes.data.data).map((key) => ({
      value: fetchedTaxes.data.data[key].uuid,
      label: `${fetchedTaxes.data.data[key].tax.toString()}%`
    }));


    propertyTaxes.value = taxOptions;
  }
  function formatPropertyValueData(data) {
    return data.propertyValues.reduce((accumulator: Record<string, string>, propertyValue: PropertyValue) => {
      accumulator[propertyValue.uuid] = propertyValue.value;
      return accumulator;
    }, {});
  }

  async function loadBrand(id, cachedOption) {
    selectedBrand.value = {
      name: cachedOption.label,
      uuid: cachedOption.label == cachedOption.value ? '' : cachedOption.value
    }
  }

  function setCommitEventListener(node) {
    node.on('commit', ({ payload }) => {
      if(!payload.length) {
        selectedBrand.value = null;
      }
    })
  }


  const productStore = useProductStore();
  const invokeGetProductPrototype = () => {
    productStore.getProductPrototype();
  };
  invokeGetProductPrototype()
  const productPrototype = computed(() => productStore.getProductPrototype());

  async function getTypesGeolocationOptions() {
    const fetchTypesGeolocationOptions = await ApiService.get('properties/7d4e611a-2d5f-11ee-9793-de1ca4386011');
    typesGeolocationUuid.value = [];
    geolocationOptions.value = [];
    fetchTypesGeolocationOptions.data.data.propertyValues.forEach((val: any) => {
      typesGeolocationUuid.value[val.value] = val.uuid;
      let label = '';
      switch (val.value) {
        case 'Manual':
          label = 'Manuelle';
          break;
        case 'Api':
          label = 'Depuis l\'API';
          break;
        default:
          label = 'Géolocalisation désactivée';
      }
      geolocationOptions.value.push({
        label: label,
        value: val.uuid
      });
    });
      geolocation_type.value = '';
  }

  async function searchSuppliers({search}) {
    if (!search || search.length < 3) return [];
    const fetchSuppliers = await ApiService.get(`suppliers?name=${search || ''}&isActive=true`);
    return fetchSuppliers.data.data.map((val: any) => {
      return {
        label: val.name,
        value: val.uuid
      }
    });
  }


  watch(
    supplier_model,
    (value) => {
      if (!value) {
        optionsShippingMethods.value = [];
        shippingMethod_model.value = null;
        return;
      }
      ApiService.get(`suppliers/${value}/shipping_methods?status=1&itemsPerPage=1000`).then(({data}) => {
        optionsShippingMethods.value = data.data.map((val: any) => {
          return {
            label: val.name,
            value: val.uuid
          }
        });
      });

    },
    {immediate: true}
  );



  const generateReference = () => {
    let reference = '';
    let hasLetter = false;
    let hasDigit = false;

    while (reference.length < 13) {
      const charCode = Math.floor(Math.random() * (122 - 48 + 1) + 48);
      if ((charCode >= 48 && charCode <= 57) || (charCode >= 65 && charCode <= 90)) {
        reference += String.fromCharCode(charCode);
        if (charCode >= 65) hasLetter = true;
        if (charCode >= 48 && charCode <= 57) hasDigit = true;
      }
    }

    if (!hasLetter) reference = reference.slice(0, -1) + 'A';
    if (!hasDigit) reference = reference.slice(0, -2) + '1' + reference.slice(-1);

    return reference;
  };

  const reference = ref(generateReference());
 

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_FormKit, {
          type: "text",
          name: "reference",
          label: "Référence produit*",
          value: reference.value,
          placeholder: "Référence produit",
          validation: "required|length:0,255",
          "validation-messages": {
            required: 'Ce champ est obligatoire.',
            length: 'Ce champ doit contenir maximum 255 caractères.',
          }
        }, null, 8, ["value", "validation-messages"]),
        _createVNode(_component_FormKit, {
          type: "taglist",
          name: "brands",
          label: "Marque*",
          options: searchBrands,
          max: "1",
          validation: "required|maxBrandLength",
          "validation-rules": { maxBrandLength: maxBrandLength },
          "validation-messages": {
            required: 'Ce champ est obligatoire.',
            maxBrandLength: 'Ce champ doit contenir maximum 50 caractères.',
          },
          "allow-new-values": true,
          "empty-message": "Aucun résultat",
          "option-loader": loadBrand,
          onNode: setCommitEventListener
        }, null, 8, ["validation-rules", "validation-messages"]),
        _createVNode(_component_FormKit, {
          type: "hidden",
          name: "brand",
          modelValue: selectedBrand.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedBrand).value = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_FormKit, {
          type: "text",
          name: "productName",
          label: "Nom du produit dans la boutique*",
          validation: "length:0,255|required",
          "validation-messages": {
            required: 'Ce champ est obligatoire.',
            length: 'Ce champ doit contenir maximum 255 caractères.',
          },
          placeholder: "Nom du produit dans la boutique"
        }, null, 8, ["validation-messages"]),
        _createVNode(_component_FormKit, {
          type: "text",
          name: "adminProductName",
          label: "Nom du produit dans le backoffice",
          placeholder: "Nom du produit dans le backoffice",
          validation: "length:0,255",
          "validation-messages": {
            length: 'Ce champ doit contenir maximum 255 caractères.',
          }
        }, null, 8, ["validation-messages"]),
        _createVNode(_component_FormKit, {
          type: "text",
          name: "shortDescription",
          label: "Description courte",
          placeholder: "Description courte",
          validation: "length:0,255",
          "validation-messages": {
            length: 'Ce champ doit contenir maximum 255 caractères.',
          }
        }, null, 8, ["validation-messages"]),
        _createVNode(_component_FormKit, {
          type: "select",
          name: "urssafClassification",
          label: "Sélectionner une catégorie",
          placeholder: "Sélectionner une catégorie",
          options: _unref(urssafClassification).values
        }, null, 8, ["options"]),
        _createVNode(_component_FormKit, {
          type: "taglist",
          multiple: "",
          name: "urssafEvent",
          label: "Sélectionner un/des évènement(s)",
          placeholder: "Sélectionner un/des évènement(s)",
          options: _unref(urssafEvent).values
        }, null, 8, ["options"]),
        _createVNode(_component_FormKit, {
          type: "taglist",
          multiple: "",
          name: "socialEvent",
          validation: "required",
          label: "Sélectionner un/des évènement(s) ou catégorie(s)*",
          placeholder: "Sélectionner un/des évènement(s) ou catégorie(s)",
          options: _unref(socialEvent)
        }, null, 8, ["options"])
      ]),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("ProductForm.StatusBloc.title")), 1),
        _createVNode(_component_FormKit, {
          type: "checkbox",
          label:  _ctx.$t('ProductForm.StatusBloc.status') ,
          name: "active",
          value: true
        }, null, 8, ["label"]),
        _createVNode(_component_FormKit, {
          type: "checkbox",
          label:  _ctx.$t('ProductForm.StatusBloc.closedLabel') ,
          name: "closedSale",
          modelValue: _unref(is_sale_closed),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(is_sale_closed) ? (is_sale_closed).value = $event : is_sale_closed = $event))
        }, null, 8, ["label", "modelValue"]),
        _createVNode(_component_FormKit, {
          type: "checkbox",
          label:  _ctx.$t('ProductForm.StatusBloc.hiddenLabel') ,
          name: "hiddenProduct"
        }, null, 8, ["label"]),
        _createVNode(_component_FormKit, {
          type: "date",
          name: "enableDate",
          label: "Date d'activation"
        }),
        _createVNode(_component_FormKit, {
          type: "date",
          name: "disableDate",
          label: "Date de désactivation"
        }),
        (_unref(is_sale_closed))
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 0,
              type: "text",
              label: "Motif de la fermeture*",
              validation: "required|length:0,255",
              modelValue: closure_reason.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((closure_reason).value = $event)),
              "validation-messages": {
            required: 'Ce champ est obligatoire.',
            length: 'Ce champ doit contenir maximum 255 caractères.'
          },
              name: "saleClosingReason"
            }, null, 8, ["modelValue", "validation-messages"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", _hoisted_6, [
        _hoisted_7,
        (  
          productPrototype.value !== '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f' &&
          productPrototype.value !== '6a401dea-fdfd-11ed-a0b1-de1c3c38600f'
        )
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 0,
              type: "checkbox",
              label: "Envoi différé",
              name: "delayedSending"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_FormKit, {
          type: "autocomplete",
          label: "Fournisseur*",
          name: "supplier",
          validation: "required",
          "validation-messages": {
              required: 'Veuillez sélectionner un fournisseur.',
            },
          placeholder: "Sélectionner un fournisseur",
          options: searchSuppliers,
          modelValue: _unref(supplier_model),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(supplier_model) ? (supplier_model).value = $event : supplier_model = $event))
        }, null, 8, ["validation-messages", "modelValue"]),
        (productPrototype.value !== '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f' &&
              productPrototype.value !== '6a401dea-fdfd-11ed-a0b1-de1c3c38600f'
        )
          ? (_openBlock(), _createBlock(_component_FormKit, {
              key: 1,
              type: "taglist",
              multiple: "",
              label: "Moyen d’expédition*",
              name: "shippingMethod",
              placeholder: "Sélectionner un moyen d'expédition",
              validation: "required",
              options: _unref(optionsShippingMethods),
              modelValue: _unref(shippingMethod_model),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(shippingMethod_model) ? (shippingMethod_model).value = $event : shippingMethod_model = $event)),
              "validation-messages": {
              required: 'Au moins un moyen d’expédition doit être associé au produit.',
            }
            }, null, 8, ["options", "modelValue", "validation-messages"]))
          : _createCommentVNode("", true)
      ]),
      (productPrototype.value !== '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f' && 
            productPrototype.value !== '6a401dea-fdfd-11ed-a0b1-de1c3c38600f'
      )
        ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_FormKit, {
                type: "number",
                label: "Stock*",
                palceholder: "Stock",
                name: "stock",
                validation: "required|matches:/^\\d+$/",
                "validation-messages": {
                    required: 'Ce champ est obligatoire.',
                    matches: 'Veuillez entrer un nombre entier.'
                }
              }, null, 8, ["validation-messages"]),
              _createVNode(_component_FormKit, {
                type: "number",
                name: "stockAlertThreshold",
                label: "Seuil rupture de stock",
                palceholder: "Seuil rupture de stock",
                validation: "matches:/^\\d+$/",
                "validation-messages": {
                    matches: 'Veuillez entrer un nombre entier.'
                }
              }, null, 8, ["validation-messages"])
            ]),
            _createVNode(_component_FormKit, {
              type: "number",
              label: "Limite/panier",
              name: "limitByCart",
              validation: "matches:/^\\d+$/",
              "validation-messages": {
            matches: 'Veuillez entrer un nombre entier.'
        }
            }, null, 8, ["validation-messages"]),
            _createVNode(_component_FormKit, {
              type: "number",
              label: "Limite/user",
              name: "limitByUser",
              validation: "matches:/^\\d+$/",
              "validation-messages": {
            matches: 'Veuillez entrer un nombre entier.'
        }
            }, null, 8, ["validation-messages"])
          ]))
        : _createCommentVNode("", true),
      (productPrototype.value == '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f' )
        ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_FormKit, {
              type: "text",
              label: "Identifiant",
              name: "identifiant",
              validation: "length:0,100",
              "validation-messages": {
                length: 'Ce champ doit contenir maximum 100 caractères.',
              }
            }, null, 8, ["validation-messages"]),
            _createVNode(_component_FormKit, {
              type: "text",
              label: "Mot de passe",
              name: "password",
              validation: "length:0,100",
              "validation-messages": {
                length: 'Ce champ doit contenir maximum 100 caractères.',
              }
            }, null, 8, ["validation-messages"])
          ]))
        : _createCommentVNode("", true),
      (productPrototype.value !== '6a3f537e-fdfd-11ed-a0b1-de1c3c38600f' && 
            productPrototype.value !== '6a3fc06d-fdfd-11ed-a0b1-de1c3c38600f' && 
            productPrototype.value !=='6a3fe435-fdfd-11ed-a0b1-de1c3c38600f'
      )
        ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_FormKit, {
              type: "text",
              name: "redirectionLink",
              label: "Lien de redirection",
              placeholder: "https://www.example.com...",
              validation: "length:0,1400",
              "validation-messages": {
            length: 'Ce champ doit contenir maximum 1400 caractères.',
          }
            }, null, 8, ["validation-messages"]),
            _createVNode(_component_FormKit, {
              type: "radio",
              label: "Type de réduction",
              name: "reductionType",
              options: [
            {label : 'Champ libre', value : 1},
            {label : 'En Pourcentage %', value : 2},
            {label : 'En euros €', value : 3}
        ],
              modelValue: _unref(discount_type),
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(discount_type) ? (discount_type).value = $event : discount_type = $event)),
              validation: "required"
            }, null, 8, ["modelValue"]),
            (_unref(discount_type) == 1)
              ? (_openBlock(), _createBlock(_component_FormKit, {
                  key: 0,
                  type: "textarea",
                  name: "reductionDescription",
                  modelValue: reductionDescriptionClosed.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((reductionDescriptionClosed).value = $event)),
                  label: "Description de la réduction*",
                  validation: "required|length:0,255",
                  "validation-messages": {
            length: 'Ce champ doit contenir maximum 255 caractères.',
            required: 'Ce champ est obligatoire.',
          }
                }, null, 8, ["modelValue", "validation-messages"]))
              : (_openBlock(), _createBlock(_component_FormKit, {
                  key: 1,
                  type: "number",
                  name: "reductionValue",
                  label: "Réduction*",
                  modelValue: reductionValueClosed.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((reductionValueClosed).value = $event)),
                  validation: "required|matches:/^[0-9]\\d*$/",
                  "validation-messages": {
          required: 'Ce champ est obligatoire.',
          matches: 'Veuillez entrer un nombre entier positif.'
        }
                }, null, 8, ["modelValue", "validation-messages"]))
          ]))
        : _createCommentVNode("", true),
      (productPrototype.value !== '6a3f537e-fdfd-11ed-a0b1-de1c3c38600f' && 
          productPrototype.value !== '6a3fc06d-fdfd-11ed-a0b1-de1c3c38600f' && 
          productPrototype.value !=='6a3fe435-fdfd-11ed-a0b1-de1c3c38600f' &&
          productPrototype.value !=='6a401dea-fdfd-11ed-a0b1-de1c3c38600f'
    )
        ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_FormKit, {
              type: "text",
              name: "webPromoCode",
              label: "Code promo internet",
              validation: "length:0,255",
              "validation-messages": {
          length: 'Ce champ doit contenir maximum 255 caractères.',
        }
            }, null, 8, ["validation-messages"]),
            _createVNode(_component_FormKit, {
              type: "tel",
              label: "Numéro de téléphone",
              name: "phone",
              placeholder: "xx xx xx xx",
              modelValue: phoneNumber.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((phoneNumber).value = $event)),
              validation: phoneNumberValidation.value,
              "validation-messages": {
          length: 'Ce champ doit contenir maximum 20 caractères.',
          required: 'Ce champ est obligatoire si le code promo est renseigné.',
        },
              "validation-visibility": "dirty"
            }, null, 8, ["modelValue", "validation", "validation-messages"]),
            _createVNode(_component_FormKit, {
              type: "text",
              label: "Code promo téléphone",
              name: "codePromoPhone",
              modelValue: promoCode.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((promoCode).value = $event)),
              validation: "length:0,255",
              "validation-messages": {
          length: 'Ce champ doit contenir maximum 255 caractères.',
        }
            }, null, 8, ["modelValue", "validation-messages"]),
            _createVNode(_component_FormKit, {
              type: "number",
              step: "any",
              label: "Prix d’appel",
              name: "callPrice",
              "validation-rules": { maximumDecimals: maximumDecimals },
              validation: "length:0,20|maximumDecimals",
              "validation-messages": {
          length: 'Ce champ doit contenir maximum 20 caractères.',
          maximumDecimals: maximumDecimalsError,
        }
            }, null, 8, ["validation-rules", "validation-messages"])
          ]))
        : _createCommentVNode("", true),
      (
          productPrototype.value !== '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f' && 
          productPrototype.value !== '6a401dea-fdfd-11ed-a0b1-de1c3c38600f'
      )
        ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_FormKit, {
                  type: "select",
                  label: "Monnaie",
                  name: "country",
                  options: [
              {label :'€',value :'FR', attrs: { disabled: false }},
              {label :'$',value :'EN',  attrs: { disabled: true }}
            ]
                })
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_FormKit, {
                  type: "number",
                  step: "any",
                  label: "Prix de vente*",
                  "validation-rules": { maximumDecimals: maximumDecimals },
                  validation: "required|maximumDecimals",
                  "validation-messages": {
                required: 'Ce champ est obligatoire.',
                maximumDecimals: maximumDecimalsError,
            },
                  name: "price"
                }, null, 8, ["validation-rules", "validation-messages"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_FormKit, {
                  type: "select",
                  label: "Taxes*",
                  name: "tax",
                  placeholder: "Sélectionner une taxe",
                  validation: "required",
                  "validation-messages": {
              required: 'Ce champ est obligatoire.',
            },
                  options: _unref(taxes).values
                }, null, 8, ["validation-messages", "options"])
              ]),
              _createElementVNode("div", null, [
                (_unref(is_discount) == 1)
                  ? (_openBlock(), _createBlock(_component_FormKit, {
                      key: 0,
                      type: "number",
                      step: "any",
                      label: "Prix public*",
                      name: "publicPrice",
                      modelValue: publicPriceClosed.value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((publicPriceClosed).value = $event)),
                      "validation-rules": { maximumDecimals: maximumDecimals },
                      validation: "required|maximumDecimals",
                      "validation-messages": {
                required: 'Ce champ est obligatoire.',
                maximumDecimals: maximumDecimalsError,
            }
                    }, null, 8, ["modelValue", "validation-rules", "validation-messages"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_FormKit, {
                  type: "number",
                  step: "any",
                  label: "Prix d’achat",
                  name: "purchasingPrice",
                  "validation-rules": { maximumDecimals: maximumDecimals },
                  validation: "maximumDecimals",
                  "validation-messages": {
                  maximumDecimals: maximumDecimalsError,
              }
                }, null, 8, ["validation-rules", "validation-messages"])
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_FormKit, {
                type: "radio",
                label: "Type de réduction",
                name: "reductionTypeAsReduction",
                options: [
               {label : 'Pas de réduction', value : 2},
               {label : 'Prix avec réduction', value : 1}
            ],
                validation: "required",
                modelValue: _unref(is_discount),
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(is_discount) ? (is_discount).value = $event : is_discount = $event))
              }, null, 8, ["modelValue"])
            ])
          ]))
        : _createCommentVNode("", true),
      (productPrototype.value !== '6a3f537e-fdfd-11ed-a0b1-de1c3c38600f' && 
            productPrototype.value !== '6a3fc06d-fdfd-11ed-a0b1-de1c3c38600f' && 
            productPrototype.value !== '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f'&& 
            productPrototype.value !== '6a401dea-fdfd-11ed-a0b1-de1c3c38600f'
    )
        ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
            _hoisted_25,
            _createVNode(_component_FormKit, {
              type: "checkbox",
              label: "Utilisable en magasin",
              name: "usableInStore",
              value: true
            }),
            _createVNode(_component_FormKit, {
              type: "checkbox",
              label: "Utilisable en ligne",
              name: "usableOnline",
              value: true
            }),
            _createVNode(_component_FormKit, {
              type: "radio",
              label: "Utilisation drive",
              name: "usableInDrive",
              options: driveOptions,
              modelValue: selectedDriveOption.value,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selectedDriveOption).value = $event))
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", null, [
          (_unref(geolocationOptions))
            ? (_openBlock(), _createBlock(_component_FormKit, {
                key: 0,
                type: "radio",
                label: "Type de récupération des adresses",
                name: "geolocationType",
                options: _unref(geolocationOptions),
                modelValue: _unref(geolocation_type),
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(geolocation_type) ? (geolocation_type).value = $event : geolocation_type = $event)),
                validation: "required",
                "validation-messages": {
                required: 'Ce champ est obligatoire.',
            }
              }, null, 8, ["options", "modelValue", "validation-messages"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          (_unref(typesGeolocationUuid) && (_unref(geolocation_type) == _unref(typesGeolocationUuid)['Api']))
            ? (_openBlock(), _createBlock(_component_FormKit, {
                key: 0,
                type: "text",
                name: "geolocationApiKey",
                modelValue: geolocationApiKeyClosed.value,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((geolocationApiKeyClosed).value = $event)),
                label: "Recherche dans l'API",
                validation: "required|length:0,200|matches:/^[a-zA-ZÀ-ÖØ-öø-ÿ0-9\\s]+$/",
                "validation-messages": {
            length: 'Ce champ doit contenir maximum 200 caractères.',
            required: 'Ce champ est obligatoire.',
            matches: 'Seuls les lettres et les nombres sont acceptés.'
          }
              }, null, 8, ["modelValue", "validation-messages"]))
            : _createCommentVNode("", true),
          (_unref(typesGeolocationUuid) && (_unref(geolocation_type) == _unref(typesGeolocationUuid)['Manual']))
            ? (_openBlock(), _createBlock(_component_FormKit, {
                key: 1,
                id: "repeater",
                name: "geolocationAddresses",
                type: "repeater",
                label: "Adresses",
                "add-label": "+",
                min: "1",
                max: "10",
                modelValue: geolocationAddresses.value,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((geolocationAddresses).value = $event))
              }, {
                default: _withCtx(({ index }) => [
                  _createVNode(FormGeolocation, {
                    index: index,
                    number: index + 1,
                    reference: geolocationAddresses.value[index],
                    optionsCountry: _unref(optionsCountry)
                  }, null, 8, ["index", "number", "reference", "optionsCountry"])
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})